import { render, staticRenderFns } from "./hotelManEditHotelService.vue?vue&type=template&id=152c9635&scoped=true"
import script from "./hotelManEditHotelService.vue?vue&type=script&lang=js"
export * from "./hotelManEditHotelService.vue?vue&type=script&lang=js"
import style0 from "./hotelManEditHotelService.vue?vue&type=style&index=0&id=152c9635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c9635",
  null
  
)

export default component.exports